import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import BuilderJS6Simple from './BuilderJS6Simple';
import { toast } from 'react-toastify';
import AxiosInstance from '../../AxiosInstance';

const BuilderJS6SimplePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState(null);
  const [isLoading, setIsLoading] = useState(!!id);

  useEffect(() => {
    if (id) {
      loadTemplate(id);
    }
  }, [id]);

  const loadTemplate = async (templateId) => {
    try {
      setIsLoading(true);
      const response = await AxiosInstance.get(`/api/templates/${templateId}`);
      if (response.data && response.data.content) {
        setInitialData(response.data.content);
      }
    } catch (error) {
      toast.error('Failed to load template');
    } finally {
      setIsLoading(false);
    }
  };

  // Save function (as per documentation)
  const handleSave = async (jsonData) => {
    try {
      if (id) {
        await AxiosInstance.put(`/api/templates/${id}`, {
          content: jsonData
        });
        toast.success('Template updated successfully');
      } else {
        const response = await AxiosInstance.post('/api/templates', {
          name: `Template ${new Date().toLocaleString()}`,
          content: jsonData
        });
        toast.success('Template saved successfully');
        if (response.data && response.data._id) {
          navigate(`/builderjs6-simple/${response.data._id}`);
        }
      }
    } catch (error) {
      toast.error('Failed to save template');
    }
  };

  // Export function (as per documentation)
  const handleExport = (html) => {
    const blob = new Blob([html], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `email-template-${Date.now()}.html`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    toast.success('Template exported successfully');
  };

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <div>Loading template...</div>
      </div>
    );
  }

  return (
    <div style={{ width: '100%', height: '100vh', overflow: 'hidden' }}>
      <BuilderJS6Simple
        initialData={initialData}
        onSave={handleSave}
        onExport={handleExport}
        themeUrl="/themes/standard/Y0_Blank"
      />
    </div>
  );
};

export default BuilderJS6SimplePage;

